import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';

import store from './store';

import './validation';

Vue.config.productionTip = process.env.NODE_ENV !== 'production';

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_G_RECAPTCHA_SITE_KEY });

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
